interface ProjectManagerCardProps {
  manager: {
    name: string;
    email: string;
    phone?: string;
    avatar?: string;
  };
}

export const ProjectManagerCard = ({ manager }: ProjectManagerCardProps) => {
  return (
    <div className="bg-white p-3.5 rounded-xl border border-gray-200">
      <h3 className="text-sm font-bold text-gray-900 mb-2">Project Manager</h3>
      <div className="flex items-center gap-3">
        {manager.avatar ? (
          <div
            className="w-10 h-10 rounded-full bg-cover bg-center"
            style={{ backgroundImage: `url('${manager.avatar}')` }}
          />
        ) : (
          <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center">
            <span className="material-symbols-outlined text-primary">person</span>
          </div>
        )}
        <div className="flex-1">
          <p className="font-semibold text-gray-800">{manager.name}</p>
          <a
            href={`mailto:${manager.email}`}
            className="text-sm text-gray-600 hover:text-primary hover:underline"
          >
            {manager.email}
          </a>
          {manager.phone && (
            <a
              href={`tel:${manager.phone}`}
              className="block text-sm text-gray-600 hover:text-primary hover:underline"
            >
              {manager.phone}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};


